import { Text } from "@fluentui/react-components";
import { Info16Regular } from "@fluentui/react-icons";
import styled from "styled-components";

import { ButtonWithTooltip } from "components/ButtonWithTooltip/ButtonWithTooltip";
import { FadeEnter } from "components/effects/FadeEnter";
import { Flex } from "components/styled";

type Props = {
  title: string;
  value: string;
  decimalValue: string;
  infoContent: string;
  currency: string;
};

export function PaymentsCard({ title, value, decimalValue, infoContent, currency }: Props) {
  return (
    <FadeEnter>
      <Container>
        <Flex $justify="space-between" width={"100%"} style={{
          height: "35px"
        }}>
          <Title weight="bold">{title}</Title>
          {infoContent && <ButtonWithTooltip tooltipContent={infoContent} icon={<Info16Regular />} />}
        </Flex>
        <Flex $gap={"1px"}>
          <StyledValue>{value}.</StyledValue>
          <StyledValue $gray>{decimalValue}</StyledValue>
          <StyledValue $gray $currency>
            {currency}
          </StyledValue>
        </Flex>
      </Container>
    </FadeEnter>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  padding: 5px 10px 10px;
  gap: 35px;
  background: ${(props) => props.theme.semanticColors.cardStandoutBackground};
  border: 1px solid ${(props) => props.theme.palette.neutralLight};
  border-radius: 6px;
  height: 136px;
`;

const Title = styled(Text)`
  font-size: 15px !important;
`;

const StyledValue = styled(Text)<{ $gray?: boolean; $currency?: boolean }>`
  font-size: 26px !important;
  font-weight: ${(props) => (props.$currency ? "400" : "800")};
  color: ${({ theme, $gray }) =>
    $gray ? theme.semanticColors.disabledBodySubtext : theme.palette.black};
`;
